import { useState } from "react";
import { CloseMenu } from "../../icons/CloseMenu";
import { OpenMenu } from "../../icons/OpenMenu";
import NavProps from "./NavProps";
import Logo from "../../icons/Logo";
import LogoCherry from "../../icons/LogoCherry";
import { useLocation } from "react-router-dom";
import LanguageSelector from "../LanguageSelector";
import { Spotify } from "../../icons/Spotify";
import { Instagram } from "../../icons/Instagram";
import { Youtube } from "../../icons/Youtube";
import { useTranslation } from "react-i18next";

function NavbarMobile() {
  const [isActive, setIsActive] = useState(false);
  const [style, setStyle] = useState("#F2F2F2");
  const homeUrl = useLocation().pathname;
  const { t } = useTranslation();

  function toggle() {
    setIsActive((isActive) => !isActive);
  }

  const changeLinkColor = () => {
    if (isActive) {
      setStyle(style);
    } else {
      setStyle("rgba(32, 0, 15, 1)");
    }
  };

  return (
    <section className="navbar-mobile-container container">
      <div
        onClick={() => setIsActive(!isActive)}
        className="navbar-mobile-content"
        style={{
          backgroundColor: `${homeUrl === "/" || isActive ? "transparent" : "#F2F2F2"}`,
        }}
      >
        <div className="mobile-logo">
          {homeUrl === "/" ? <Logo /> : <LogoCherry />}
        </div>
        <div className="mobile-menu">
          {isActive ? <CloseMenu /> : <OpenMenu />}
        </div>
      </div>

      <div
        onClick={() => {
          toggle();
          changeLinkColor();
        }}
        className={style ? "navbar-mobile changeLinkColor" : "navbar-mobile "}
      >
        {isActive && (
          <div className="navbar-mobile-active">
            <div className="lng-selector-mobile">
              <LanguageSelector />
              <NavProps
                data={t("nav", { returnObjects: true }) as []}
                style={{
                  color: `${homeUrl === "/" ? "#F2F2F2" : "rgba(32, 0, 15, 1)"}`,
                }}
              />
              <hr />
              <div className="social-media-mobile">
                <Spotify />
                <Instagram />
                <Youtube />
              </div>
            </div>
          </div>
        )}
      </div>
    </section>
  );
}

export default NavbarMobile;
